import React from "react";
import { NavLink } from "react-router-dom";
import styles from "./Footer.module.css";
import { useSelector } from "react-redux";

function Footer({ contained = false }) {
  const accountType = useSelector(
    (state) => state.userData.loginData.account_type
  );
  return (
    <div
      className={`${styles.footer} ${contained ? styles.contained : ""}`}
    >
      <NavLink
        to="/"
        className={({ isActive }) =>
          `${styles.footerLink} ${isActive ? styles.activeLink : ""}`
        }
      >
        <svg
          width="16"
          height="17"
          viewBox="0 0 16 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.6693 15.1682H3.33594C3.15913 15.1682 2.98956 15.098 2.86453 14.9729C2.73951 14.8479 2.66927 14.6783 2.66927 14.5015V9.1682H1.33594L7.5306 2.97287C7.59252 2.91088 7.66605 2.86171 7.74698 2.82816C7.82791 2.79461 7.91466 2.77734 8.00227 2.77734C8.08988 2.77734 8.17663 2.79461 8.25756 2.82816C8.3385 2.86171 8.41202 2.91088 8.47394 2.97287L14.6693 9.1682H13.3359V14.5015C13.3359 14.6783 13.2657 14.8479 13.1407 14.9729C13.0157 15.098 12.8461 15.1682 12.6693 15.1682ZM6.66927 10.5015H9.33594V13.8349H12.0026V8.38687L8.0026 4.38687L4.0026 8.38687V13.8349H6.66927V10.5015Z"
            fill="#BABABA"
          />
        </svg>
        <span className={styles.linkText}>Home</span>
      </NavLink>
      <NavLink
        to="/customers"
        className={({ isActive }) =>
          `${styles.footerLink} ${isActive ? styles.activeLink : ""}`
        }
      >
        <svg
          width="17"
          height="17"
          viewBox="0 0 17 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3.66667 13.8333C4.03486 13.8333 4.33333 13.5349 4.33333 13.1667C4.33333 12.7985 4.03486 12.5 3.66667 12.5C3.29848 12.5 3 12.7985 3 13.1667C3 13.5349 3.29848 13.8333 3.66667 13.8333Z"
            fill="#BABABA"
          />
          <path d="M3 3.16797H4.33333V9.16797H3V3.16797Z" fill="#BABABA" />
          <path
            d="M5.00521 1.83203H2.33854C2.16173 1.83203 1.99216 1.90227 1.86714 2.02729C1.74211 2.15232 1.67188 2.32189 1.67188 2.4987V14.4987C1.67188 14.6755 1.74211 14.8451 1.86714 14.9701C1.99216 15.0951 2.16173 15.1654 2.33854 15.1654H5.00521C5.18202 15.1654 5.35159 15.0951 5.47661 14.9701C5.60164 14.8451 5.67188 14.6755 5.67188 14.4987V2.4987C5.67188 2.32189 5.60164 2.15232 5.47661 2.02729C5.35159 1.90227 5.18202 1.83203 5.00521 1.83203ZM5.00521 14.4987H2.33854V2.4987H5.00521V14.4987Z"
            fill="#BABABA"
          />
          <path
            d="M8.33854 13.8333C8.70673 13.8333 9.00521 13.5349 9.00521 13.1667C9.00521 12.7985 8.70673 12.5 8.33854 12.5C7.97035 12.5 7.67188 12.7985 7.67188 13.1667C7.67188 13.5349 7.97035 13.8333 8.33854 13.8333Z"
            fill="#BABABA"
          />
          <path
            d="M7.67188 3.16797H9.00521V9.16797H7.67188V3.16797Z"
            fill="#BABABA"
          />
          <path
            d="M9.66927 1.83203H7.0026C6.82579 1.83203 6.65622 1.90227 6.5312 2.02729C6.40618 2.15232 6.33594 2.32189 6.33594 2.4987V14.4987C6.33594 14.6755 6.40618 14.8451 6.5312 14.9701C6.65622 15.0951 6.82579 15.1654 7.0026 15.1654H9.66927C9.84608 15.1654 10.0157 15.0951 10.1407 14.9701C10.2657 14.8451 10.3359 14.6755 10.3359 14.4987V2.4987C10.3359 2.32189 10.2657 2.15232 10.1407 2.02729C10.0157 1.90227 9.84608 1.83203 9.66927 1.83203ZM9.66927 14.4987H7.0026V2.4987H9.66927V14.4987Z"
            fill="#BABABA"
          />
          <path
            d="M13.0026 13.8333C13.3708 13.8333 13.6693 13.5349 13.6693 13.1667C13.6693 12.7985 13.3708 12.5 13.0026 12.5C12.6344 12.5 12.3359 12.7985 12.3359 13.1667C12.3359 13.5349 12.6344 13.8333 13.0026 13.8333Z"
            fill="#BABABA"
          />
          <path
            d="M12.3359 3.16797H13.6693V9.16797H12.3359V3.16797Z"
            fill="#BABABA"
          />
          <path
            d="M14.3333 1.83203H11.6667C11.4899 1.83203 11.3203 1.90227 11.1953 2.02729C11.0702 2.15232 11 2.32189 11 2.4987V14.4987C11 14.6755 11.0702 14.8451 11.1953 14.9701C11.3203 15.0951 11.4899 15.1654 11.6667 15.1654H14.3333C14.5101 15.1654 14.6797 15.0951 14.8047 14.9701C14.9298 14.8451 15 14.6755 15 14.4987V2.4987C15 2.32189 14.9298 2.15232 14.8047 2.02729C14.6797 1.90227 14.5101 1.83203 14.3333 1.83203ZM14.3333 14.4987H11.6667V2.4987H14.3333V14.4987Z"
            fill="#BABABA"
          />
        </svg>
        <span className={styles.linkText}>Customers</span>
      </NavLink>
      {accountType !== "DISTRIBUTOR" && (
        <NavLink
          to="/renew"
          className={({ isActive }) =>
            `${styles.footerLink} ${isActive ? styles.activeLink : ""}`
          }
        >
          <svg
            width="17"
            height="17"
            viewBox="0 0 17 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5.99479 7.83203L6.99479 4.83203H12.9948L13.9948 7.83203M12.9948 11.1654C12.7296 11.1654 12.4752 11.06 12.2877 10.8725C12.1001 10.6849 11.9948 10.4306 11.9948 10.1654C11.9948 9.90015 12.1001 9.64579 12.2877 9.45826C12.4752 9.27072 12.7296 9.16536 12.9948 9.16536C13.26 9.16536 13.5144 9.27072 13.7019 9.45826C13.8894 9.64579 13.9948 9.90015 13.9948 10.1654C13.9948 10.4306 13.8894 10.6849 13.7019 10.8725C13.5144 11.06 13.26 11.1654 12.9948 11.1654ZM6.99479 11.1654C6.72958 11.1654 6.47522 11.06 6.28768 10.8725C6.10015 10.6849 5.99479 10.4306 5.99479 10.1654C5.99479 9.90015 6.10015 9.64579 6.28768 9.45826C6.47522 9.27072 6.72958 9.16536 6.99479 9.16536C7.26001 9.16536 7.51436 9.27072 7.7019 9.45826C7.88944 9.64579 7.99479 9.90015 7.99479 10.1654C7.99479 10.4306 7.88944 10.6849 7.7019 10.8725C7.51436 11.06 7.26001 11.1654 6.99479 11.1654ZM13.9415 4.4987C13.8015 4.0987 13.4215 3.83203 12.9948 3.83203H6.99479C6.56813 3.83203 6.18813 4.0987 6.04813 4.4987L4.66146 8.4987V13.832C4.66146 14.0088 4.7317 14.1784 4.85672 14.3034C4.98175 14.4285 5.15131 14.4987 5.32812 14.4987H5.99479C6.1716 14.4987 6.34117 14.4285 6.4662 14.3034C6.59122 14.1784 6.66146 14.0088 6.66146 13.832V13.1654H13.3281V13.832C13.3281 14.0088 13.3984 14.1784 13.5234 14.3034C13.6484 14.4285 13.818 14.4987 13.9948 14.4987H14.6615C14.8383 14.4987 15.0078 14.4285 15.1329 14.3034C15.2579 14.1784 15.3281 14.0088 15.3281 13.832V8.4987L13.9415 4.4987ZM10.6081 2.4987C10.4681 2.0987 10.0881 1.83203 9.66146 1.83203H3.66146C3.23479 1.83203 2.85479 2.0987 2.71479 2.4987L1.32812 6.4987V11.832C1.32813 12.0088 1.39836 12.1784 1.52339 12.3034C1.64841 12.4285 1.81798 12.4987 1.99479 12.4987H2.66146C2.83827 12.4987 3.00784 12.4285 3.13286 12.3034C3.25789 12.1784 3.32812 12.0088 3.32812 11.832V9.10536C3.20507 9.06123 3.09192 8.99326 2.99515 8.90536C2.89838 8.81746 2.81988 8.71134 2.76416 8.59308C2.70843 8.47482 2.67657 8.34673 2.67038 8.21614C2.6642 8.08556 2.68382 7.95503 2.72812 7.83203C2.87479 7.43203 3.24146 7.16536 3.66146 7.16536H3.70813L4.17479 5.83203H2.66146L3.66146 2.83203H10.7215L10.6081 2.4987Z"
              fill="#BABABA"
            />
          </svg>

          <span className={styles.linkText}>Renew</span>
        </NavLink>
      )}
      {accountType === "DISTRIBUTOR" && (
        <NavLink
          to="/pins"
          className={({ isActive }) =>
            `${styles.footerLink} ${isActive ? styles.activeLink : ""}`
          }
        >
          <svg
            width="17"
            height="17"
            viewBox="0 0 17 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5.99479 7.83203L6.99479 4.83203H12.9948L13.9948 7.83203M12.9948 11.1654C12.7296 11.1654 12.4752 11.06 12.2877 10.8725C12.1001 10.6849 11.9948 10.4306 11.9948 10.1654C11.9948 9.90015 12.1001 9.64579 12.2877 9.45826C12.4752 9.27072 12.7296 9.16536 12.9948 9.16536C13.26 9.16536 13.5144 9.27072 13.7019 9.45826C13.8894 9.64579 13.9948 9.90015 13.9948 10.1654C13.9948 10.4306 13.8894 10.6849 13.7019 10.8725C13.5144 11.06 13.26 11.1654 12.9948 11.1654ZM6.99479 11.1654C6.72958 11.1654 6.47522 11.06 6.28768 10.8725C6.10015 10.6849 5.99479 10.4306 5.99479 10.1654C5.99479 9.90015 6.10015 9.64579 6.28768 9.45826C6.47522 9.27072 6.72958 9.16536 6.99479 9.16536C7.26001 9.16536 7.51436 9.27072 7.7019 9.45826C7.88944 9.64579 7.99479 9.90015 7.99479 10.1654C7.99479 10.4306 7.88944 10.6849 7.7019 10.8725C7.51436 11.06 7.26001 11.1654 6.99479 11.1654ZM13.9415 4.4987C13.8015 4.0987 13.4215 3.83203 12.9948 3.83203H6.99479C6.56813 3.83203 6.18813 4.0987 6.04813 4.4987L4.66146 8.4987V13.832C4.66146 14.0088 4.7317 14.1784 4.85672 14.3034C4.98175 14.4285 5.15131 14.4987 5.32812 14.4987H5.99479C6.1716 14.4987 6.34117 14.4285 6.4662 14.3034C6.59122 14.1784 6.66146 14.0088 6.66146 13.832V13.1654H13.3281V13.832C13.3281 14.0088 13.3984 14.1784 13.5234 14.3034C13.6484 14.4285 13.818 14.4987 13.9948 14.4987H14.6615C14.8383 14.4987 15.0078 14.4285 15.1329 14.3034C15.2579 14.1784 15.3281 14.0088 15.3281 13.832V8.4987L13.9415 4.4987ZM10.6081 2.4987C10.4681 2.0987 10.0881 1.83203 9.66146 1.83203H3.66146C3.23479 1.83203 2.85479 2.0987 2.71479 2.4987L1.32812 6.4987V11.832C1.32813 12.0088 1.39836 12.1784 1.52339 12.3034C1.64841 12.4285 1.81798 12.4987 1.99479 12.4987H2.66146C2.83827 12.4987 3.00784 12.4285 3.13286 12.3034C3.25789 12.1784 3.32812 12.0088 3.32812 11.832V9.10536C3.20507 9.06123 3.09192 8.99326 2.99515 8.90536C2.89838 8.81746 2.81988 8.71134 2.76416 8.59308C2.70843 8.47482 2.67657 8.34673 2.67038 8.21614C2.6642 8.08556 2.68382 7.95503 2.72812 7.83203C2.87479 7.43203 3.24146 7.16536 3.66146 7.16536H3.70813L4.17479 5.83203H2.66146L3.66146 2.83203H10.7215L10.6081 2.4987Z"
              fill="#BABABA"
            />
          </svg>

          <span className={styles.linkText}>Pins</span>
        </NavLink>
      )}
      {accountType !== "DISTRIBUTOR" && (
        <NavLink
          to="/fixed-agent/pins"
          className={({ isActive }) =>
            `${styles.footerLink} ${isActive ? styles.activeLink : ""}`
          }
        >
          <svg
            width="17"
            height="17"
            viewBox="0 0 17 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5.99479 7.83203L6.99479 4.83203H12.9948L13.9948 7.83203M12.9948 11.1654C12.7296 11.1654 12.4752 11.06 12.2877 10.8725C12.1001 10.6849 11.9948 10.4306 11.9948 10.1654C11.9948 9.90015 12.1001 9.64579 12.2877 9.45826C12.4752 9.27072 12.7296 9.16536 12.9948 9.16536C13.26 9.16536 13.5144 9.27072 13.7019 9.45826C13.8894 9.64579 13.9948 9.90015 13.9948 10.1654C13.9948 10.4306 13.8894 10.6849 13.7019 10.8725C13.5144 11.06 13.26 11.1654 12.9948 11.1654ZM6.99479 11.1654C6.72958 11.1654 6.47522 11.06 6.28768 10.8725C6.10015 10.6849 5.99479 10.4306 5.99479 10.1654C5.99479 9.90015 6.10015 9.64579 6.28768 9.45826C6.47522 9.27072 6.72958 9.16536 6.99479 9.16536C7.26001 9.16536 7.51436 9.27072 7.7019 9.45826C7.88944 9.64579 7.99479 9.90015 7.99479 10.1654C7.99479 10.4306 7.88944 10.6849 7.7019 10.8725C7.51436 11.06 7.26001 11.1654 6.99479 11.1654ZM13.9415 4.4987C13.8015 4.0987 13.4215 3.83203 12.9948 3.83203H6.99479C6.56813 3.83203 6.18813 4.0987 6.04813 4.4987L4.66146 8.4987V13.832C4.66146 14.0088 4.7317 14.1784 4.85672 14.3034C4.98175 14.4285 5.15131 14.4987 5.32812 14.4987H5.99479C6.1716 14.4987 6.34117 14.4285 6.4662 14.3034C6.59122 14.1784 6.66146 14.0088 6.66146 13.832V13.1654H13.3281V13.832C13.3281 14.0088 13.3984 14.1784 13.5234 14.3034C13.6484 14.4285 13.818 14.4987 13.9948 14.4987H14.6615C14.8383 14.4987 15.0078 14.4285 15.1329 14.3034C15.2579 14.1784 15.3281 14.0088 15.3281 13.832V8.4987L13.9415 4.4987ZM10.6081 2.4987C10.4681 2.0987 10.0881 1.83203 9.66146 1.83203H3.66146C3.23479 1.83203 2.85479 2.0987 2.71479 2.4987L1.32812 6.4987V11.832C1.32813 12.0088 1.39836 12.1784 1.52339 12.3034C1.64841 12.4285 1.81798 12.4987 1.99479 12.4987H2.66146C2.83827 12.4987 3.00784 12.4285 3.13286 12.3034C3.25789 12.1784 3.32812 12.0088 3.32812 11.832V9.10536C3.20507 9.06123 3.09192 8.99326 2.99515 8.90536C2.89838 8.81746 2.81988 8.71134 2.76416 8.59308C2.70843 8.47482 2.67657 8.34673 2.67038 8.21614C2.6642 8.08556 2.68382 7.95503 2.72812 7.83203C2.87479 7.43203 3.24146 7.16536 3.66146 7.16536H3.70813L4.17479 5.83203H2.66146L3.66146 2.83203H10.7215L10.6081 2.4987Z"
              fill="#BABABA"
            />
          </svg>

          <span className={styles.linkText}>Pins</span>
        </NavLink>
      )}
      <NavLink
        to={accountType === "DISTRIBUTOR" ? "/history/credit" : "/history"}
        className={({ isActive }) =>
          `${styles.footerLink} ${isActive ? styles.activeLink : ""}`
        }
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.3116 3.72059C15.2421 3.65045 15.1594 3.59482 15.0682 3.55695C14.9769 3.51908 14.8791 3.49972 14.7804 3.5H14.25V2.25C14.2498 2.05116 14.1707 1.86052 14.0301 1.71992C13.8895 1.57931 13.6988 1.50022 13.5 1.5H2.70709C2.12174 1.50001 1.56036 1.73254 1.14645 2.14645C0.732543 2.56036 0.500008 3.12174 0.5 3.70709V12.2929C0.500008 12.8783 0.732543 13.4396 1.14645 13.8535C1.56036 14.2675 2.12174 14.5 2.70709 14.5H14.7508C14.9492 14.4996 15.1394 14.4208 15.2799 14.2808C15.4204 14.1407 15.4998 13.9508 15.5008 13.7524L15.5303 4.25256C15.531 4.15382 15.5119 4.05594 15.4744 3.96462C15.4369 3.87329 15.3815 3.79034 15.3116 3.72059ZM14.5017 13.5H2.70709C2.38695 13.5 2.07992 13.3728 1.85355 13.1465C1.62718 12.9201 1.5 12.613 1.5 12.2929V3.70709C1.5 3.38695 1.62718 3.07992 1.85355 2.85355C2.07992 2.62718 2.38695 2.5 2.70709 2.5H13.25V3.5H2.75V4.5H14.5296L14.5017 13.5Z"
            fill="#BABABA"
          />
          <path d="M12.25 8.25H13.25V9.25H12.25V8.25Z" fill="#BABABA" />
        </svg>
        <span className={styles.linkText}>History</span>
      </NavLink>
    </div>
  );
}

export default Footer;
